// extracted by mini-css-extract-plugin
export default {"image":"cW-z","loaded":"dW-z"};